
import GenericTemplate from "./GenericTemplate";

export default GenericTemplate;